module.exports = __webpack_public_path__ + "img/CS-ECONew-Profiles.32fe591b.jpg";